// Services Img Imports
import Web from "../assets/images/Services/Web.png";
import Mobile from "../assets/images/Services/Mobile.png";
import UIUX from "../assets/images/Services/Design.png";

// Portfolio Img Imports
import landscape1 from "../assets/images/Portfolio/lanscape1.png";
import landscape2 from "../assets/images/Portfolio/landscape2.png";
import landscape3 from "../assets/images/Portfolio/landscape3.png";
import landscape4 from "../assets/images/Portfolio/landscape4.png";
import landscape5 from "../assets/images/Portfolio/landscape 5.png";
import landscape6 from "../assets/images/Portfolio/landscape6.png";
import landscape7 from "../assets/images/Portfolio/landscape17.png";
import landscape8 from "../assets/images/Portfolio/landscape18.png";
import landscape9 from "../assets/images/Portfolio/landscape19.png";
import landscape10 from "../assets/images/Portfolio/landscape20.png";

// Advantages
import Communicative from "../assets/images/Advantages/communicatin.png";
import Collaborative from "../assets/images/Advantages/Collaborative.png";
import Management from "../assets/images/Advantages/Management.png";
import Favorite from "../assets/images/Advantages/Favorite.png";

//certificates
import Certificate1 from "../assets/images/Certificate/1.png";
import Certificate2 from "../assets/images/Certificate/2.png";
import Certificate3 from "../assets/images/Certificate/3.png";
import Certificate4 from "../assets/images/Certificate/4.png";
import Certificate5 from "../assets/images/Certificate/5.png";
import Certificate6 from "../assets/images/Certificate/6.png";
import Certificate7 from "../assets/images/Certificate/7.png";
import Certificate8 from "../assets/images/Certificate/8.png";
import Certificate9 from "../assets/images/Certificate/9.png";
import Certificate10 from "../assets/images/Certificate/10.png";
import Certificate11 from "../assets/images/Certificate/11.png";
import Certificate12 from "../assets/images/Certificate/12.png";
import Certificate13 from "../assets/images/Certificate/13.png";
import Certificate14 from "../assets/images/Certificate/14.png";
import Certificate15 from "../assets/images/Certificate/15.png";
import Certificate16 from "../assets/images/Certificate/16.png";

// Testimonials
import Abebe from "../assets/images/Testimonials/3.jpg";
import Dawit from "../assets/images/Testimonials/2.jpg";
import Aster from "../assets/images/Testimonials/1.jpg";

// TeamMembers
import CEO from "../assets/images/TeamMembers/CEO.jpg";
import HRD from "../assets/images/TeamMembers/HRD.jpg";
import Finance from "../assets/images/TeamMembers/Finance.jpg";
import ProjectManager from "../assets/images/TeamMembers/Project-manager.jpg";
import Frontend1 from "../assets/images/TeamMembers/Frontend1.jpg";
import Frontend2 from "../assets/images/TeamMembers/Frontend2.jpg";
import Backend1 from "../assets/images/TeamMembers/Backend1.jpg";
import Backend2 from "../assets/images/TeamMembers/Backend2.jpg";
import Mobile1 from "../assets/images/TeamMembers/Mobile1.jpg";
import Mobile2 from "../assets/images/TeamMembers/Mobile2.jpg";
import UIUX1 from "../assets/images/TeamMembers/UIUX1.jpg";
import UIUX2 from "../assets/images/TeamMembers/UIUX2.jpg";

export const Services = [
  {
    title: "AT Landscape",
    imageUrl: Web,
    animation: "right",
    link: "/",
  },
  {
    title: "Ago-Mart supermarket",
    imageUrl: Mobile,
    animation: "right",
    link: "/LandingPage1",
  },
  {
    title: "Marine Logistics",
    imageUrl: UIUX,
    animation: "right",
    link: "/LandingPage2",
  },
];

export const Portfolios = [
  {
    id: "asd1293uasdads1",
    title: "landscape1",
    imageUrl: landscape1,
  },
  {
    id: "asd1293uhjkhkjh2",
    title: "landscape2",
    imageUrl: landscape2,
  },
  {
    id: "asd1293uvbvcbbd3",
    title: "landscape3",
    imageUrl: landscape3,
  },
  {
    id: "asd1293ufgdfgs4",
    title: "landscape4",
    imageUrl: landscape4,
  },
  {
    id: "asd1293ulskmnb5",
    title: " landscape5",
    imageUrl: landscape5,
  },
  {
    id: "asd1293ulkmnbj6",
    title: "landscape6",
    imageUrl: landscape6,
  },
  {
    id: "asd1293ulkmnbj7",
    title: "landscape7",
    imageUrl: landscape7,
  },
  {
    id: "asd1293ulkmnbj8",
    title: "landscape8",
    imageUrl: landscape8,
  },
  {
    id: "asd1293ulkmnbj9",
    title: "landscape9",
    imageUrl: landscape9,
  },
  {
    id: "asd1293ulkmnbj10",
    title: "landscape10",
    imageUrl: landscape10,
  },
];

export const Advantages = [
  [
    {
      title: "Communicative",
      description:
        "We communicate with our team and progress to make it clear.",
      imageUrl: Communicative,
    },
    {
      title: "Management",
      description:
        "We manage our company properly to make our product qualified.",
      imageUrl: Management,
    },
  ],
  [
    {
      title: "Collaborative​",
      description:
        "Our team are very collaborative to make our product qualified.",
      imageUrl: Collaborative,
    },
    {
      title: "Favorite",
      description: "We've so many products and all of our client love it.",
      imageUrl: Favorite,
    },
  ],
];

export const Certificates = [
  {
    imageUrl: Certificate1,
  },
  {
    imageUrl: Certificate2,
  },
  {
    imageUrl: Certificate3,
  },
  {
    imageUrl: Certificate4,
  },
  {
    imageUrl: Certificate5,
  },
  {
    imageUrl: Certificate6,
  },
  {
    imageUrl: Certificate7,
  },
  {
    imageUrl: Certificate8,
  },
  {
    imageUrl: Certificate9,
  },
  {
    imageUrl: Certificate10,
  },
  {
    imageUrl: Certificate11,
  },
  {
    imageUrl: Certificate12,
  },
  {
    imageUrl: Certificate13,
  },
  {
    imageUrl: Certificate14,
  },
  {
    imageUrl: Certificate15,
  },
  {
    imageUrl: Certificate16,
  },
];

export const Testimonials = [
  {
    id: 1,
    name: "Abebe Bekele",
    testimoni:
      "Thanks for Ago-Mart supermarket, you guys are the best! Keep up the great work!",
    imageUrl: Abebe,
  },
  {
    id: 2,
    name: "Aster Tadesse",
    testimoni:
      "I just wanted to let you know that it’s been great working with Marine Logistics.",
    imageUrl: Aster,
  },
  {
    id: 3,
    name: "Dawit Yohannes",
    testimoni:
      "AT landscape is so great. Thank you so much for a job well done.",
    imageUrl: Dawit,
  },
];

export const TeamMembers = [
  {
    name: "Rach David",
    position: "CEO",
    imageUrl: CEO,
  },
  {
    name: "Pauline Sydney",
    position: "Sales and Marketing manager",
    imageUrl: HRD,
  },
  {
    name: "Granger Watterson",
    position: "Finance",
    imageUrl: Finance,
  },
  {
    name: "Tom Jimmy",
    position: "Account Manager",
    imageUrl: ProjectManager,
  },
  {
    name: "Jim Hendrix",
    position: "Horticulturist ",
    imageUrl: Frontend1,
  },
  {
    name: "Calvin Max",
    position: "Office Manager",
    imageUrl: Frontend2,
  },
  {
    name: "Hawkins Jim",
    position: "Counseler",
    imageUrl: Backend1,
  },
  {
    name: "Don Bizaro",
    position: "Designer",
    imageUrl: Backend2,
  },
  {
    name: "Bill Markinson",
    position: "Equipment Operator",
    imageUrl: Mobile1,
  },
  {
    name: "Igor Kavarov",
    position: "manager",
    imageUrl: Mobile2,
  },
  {
    name: "Freddie Curl",
    position: "HR",
    imageUrl: UIUX2,
  },
  {
    name: "Monica Lovegood",
    position: "Landscape Technician/Installer",
    imageUrl: UIUX1,
  },
];
